// Zentrale Versions-Konstante. Bei Releases hier aktualisieren.
// Format: "MAJOR.MINOR.PATCH (Build YYMMDDHHmm)" in Europe/Berlin
export const APP_VERSION = "1.4.1 (Build 2610261414)";
